module.exports = __webpack_public_path__ + "img/slide5.4bd2c3d0.png";